import logo from "@/assets/logo_ikon_szurke.svg"

function Loading() {
    return (
        <div className={"w-full h-full flex flex-col items-center justify-center"}>
            <img src={logo} alt={"logo"} draggable={"false"} className={"max-w-12 box"}/>
        </div>
    )
}
export default Loading